var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStudents = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.912 4.061a1 1 0 0 1 .705.006l9.743 3.765a1 1 0 0 1 .039 1.85L19 11.159v5.482c0 .559-.28 1.08-.744 1.39l-.205.137a10.909 10.909 0 0 1-12.102 0l-.205-.137A1.67 1.67 0 0 1 5 16.641v-5.556l-1-.413V13a1 1 0 1 1-2 0V9.847l-.382-.158a1 1 0 0 1 .037-1.863l10.257-3.765Zm.743 9.856L17 12.028v4.437l-.058.039a8.908 8.908 0 0 1-9.883 0L7 16.464v-4.553l4.875 2.013a1 1 0 0 0 .78-.007ZM4.753 8.82l7.493 3.094 7.12-3.095-7.119-2.75-7.494 2.75Z",
  fill: "#5C738C"
})));
export default SvgStudents;